export type LogLevel = "debug" | "info" | "warn" | "error";

/**
 * Flat, secret-free fields only. Callers must never pass request or response
 * bodies, tokens or Telegram initData.
 */
export interface LogFields {
  correlationId?: string;
  [key: string]: string | number | boolean | undefined;
}

export interface LogRecord extends LogFields {
  level: LogLevel;
  event: string;
}

const SINK: Record<LogLevel, (record: LogRecord) => void> = {
  debug: (record) => {
    console.debug(record);
  },
  info: (record) => {
    console.info(record);
  },
  warn: (record) => {
    console.warn(record);
  },
  error: (record) => {
    console.error(record);
  },
};

function emit(level: LogLevel, event: string, fields: LogFields = {}): void {
  const defined = Object.fromEntries(
    Object.entries(fields).filter(([, value]) => value !== undefined),
  );
  SINK[level]({ ...defined, level, event });
}

/** Console-only structured logger; nothing is sent to the server. */
export const logger = {
  debug: (event: string, fields?: LogFields) => {
    emit("debug", event, fields);
  },
  info: (event: string, fields?: LogFields) => {
    emit("info", event, fields);
  },
  warn: (event: string, fields?: LogFields) => {
    emit("warn", event, fields);
  },
  error: (event: string, fields?: LogFields) => {
    emit("error", event, fields);
  },
};
